import { Chip } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import { getBootstrap } from '@/config/bootstrap';
import { env } from '@/config/env';
import { resolveTokens } from '@/theme/theme';

export function DeployEnvBadge() {
  const { t } = useTranslation();
  const tokens = resolveTokens(useTheme());
  let bootstrapEnv: string | null = null;
  try {
    bootstrapEnv = getBootstrap().deployEnv;
  } catch {
    bootstrapEnv = null;
  }
  if (bootstrapEnv !== 'staging' && env.deployEnv !== 'staging') return null;
  return (
    <Chip
      size="small"
      label={t('deployEnv.staging')}
      sx={{
        backgroundColor: tokens.warningFill,
        color: tokens.warningInk,
        '& .MuiChip-label': { color: tokens.warningInk },
      }}
    />
  );
}
